import React from 'react';
import { IconButton } from '@material-ui/core';

import Icon from 'sharedComponents/Icon';
import useStyles from './useStyles';

const SocialButtons = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <IconButton
        aria-label="facebook.com"
        onClick={() => window.open('//www.facebook.com/bundleloan', '_blank')}
        className={classes.socialButton}
      >
        <Icon name="facebook" />
      </IconButton>
      <IconButton
        aria-label="twitter.com"
        onClick={() => window.open('//twitter.com/bundleloan', '_blank')}
        className={classes.socialButton}
      >
        <Icon name="twitter" />
      </IconButton>
      <IconButton
        aria-label="Linkedin.com"
        onClick={() => window.open('//www.linkedin.com/company/bundleloan', '_blank')}
        className={classes.socialButton}
      >
        <Icon name="linkedinTeal" />
      </IconButton>
    </div>
  );
};

export default SocialButtons;



// WEBPACK FOOTER //
// ./src/sharedComponents/SocialButtons/SocialButtons.js